import React from 'react'
import ActiveStatusBadge from '../../../ui/ActiveStatusBadge/ActiveStatusBadge'
import FundItemWithAvatar from './FundItemWithAvatar'
import GiftsFundRowActions from './GiftsFundRowActions'
import styles from './GiftsFund.module.scss'

const compareNullableNumber = (a, b) => {
  if (a == null && b == null) return 0
  if (a == null) return 1
  if (b == null) return -1
  return a - b
}

export const getGiftsFundTableColumns = ({ onEdit, getRowActions }) => [
  {
    field: 'displayCode',
    headerClassName: 'TableHeadCol',
    headerName: 'Код товару',
    width: 200,
    minWidth: 180,
    valueGetter: (params) => params.row.displayCode,
  },
  {
    field: 'isActive',
    headerClassName: 'TableHeadCol',
    headerName: 'Статус',
    width: 120,
    renderCell: (params) => <ActiveStatusBadge isActive={params.row.isActive === true} />,
    sortComparator: (a, b) => Number(Boolean(b)) - Number(Boolean(a)),
  },
  {
    field: 'displayBrand',
    headerClassName: 'TableHeadCol',
    headerName: 'Бренд',
    width: 140,
    valueGetter: (params) => params.row.displayBrand,
  },
  {
    field: 'displayTitle',
    headerClassName: 'TableHeadCol',
    headerName: 'Позиція',
    flex: 1,
    minWidth: 260,
    renderCell: (params) => (
      <button type="button" className={styles.positionButton} onClick={() => onEdit(params.row)}>
        <FundItemWithAvatar
          imageUrl={params.row.imageUrl}
          title={params.row.displayTitle}
          secondary={params.row.displayTitleSecondary}
          useSetAvatar={params.row.useSetAvatar === true}
        />
      </button>
    ),
    valueGetter: (params) => params.row.displayTitle,
  },
  {
    field: 'displayVolume',
    headerClassName: 'TableHeadCol',
    headerName: 'Од. виміру',
    width: 100,
    valueGetter: (params) => params.row.displayVolume,
  },
  {
    field: 'displayType',
    headerClassName: 'TableHeadCol',
    headerName: 'Тип',
    width: 140,
    renderCell: (params) => (
      <div className={styles.typeCell}>
        <span>{params.row.displayType}</span>
        {params.row.displayTypeSecondary ? (
          <span className={styles.typeCellSecondary}>{params.row.displayTypeSecondary}</span>
        ) : null}
      </div>
    ),
    valueGetter: (params) => params.row.displayType,
  },
  {
    field: 'groupName',
    headerClassName: 'TableHeadCol',
    headerName: 'Група',
    width: 130,
  },
  {
    field: 'tierMinAmount',
    headerClassName: 'TableHeadCol',
    headerName: 'Доступна від',
    width: 170,
    renderCell: (params) => params.row.tierLabel,
    sortComparator: compareNullableNumber,
    valueGetter: (params) => params.row.tierMinAmount,
  },
  {
    field: 'remainValue',
    headerClassName: 'TableHeadCol',
    headerName: 'Наявність',
    width: 100,
    renderCell: (params) => params.row.remainLabel,
    sortComparator: compareNullableNumber,
    valueGetter: (params) => params.row.remainValue,
  },
  {
    field: 'actions',
    headerClassName: 'TableHeadCol',
    headerName: 'Дії',
    width: 72,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => <GiftsFundRowActions options={getRowActions(params.row)} />,
  },
]
